module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [(_vm.editMemo.id) ? _c('h3', [_vm._v(_vm._s('Vorgabe bearbeiten'))]) : _c('h3', [_vm._v(_vm._s('Neue Vorgabe anlegen'))]), _vm._v(" "), (false) ? _c('div', [_vm._v("\n              idCompany: " + _vm._s(_vm.editMemo.idCompany) + "\n              idUser: " + _vm._s(_vm.editMemo.idUserClient) + "\n            ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('form', {
    attrs: {
      "id": _vm._uid
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('cancel', _vm.memo)
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-type"
    }
  }, [_vm._v("Art :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMemo.typ),
      expression: "editMemo.typ"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "required": "",
      "id": "memo-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editMemo, "typ", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.MemoConf.TYP), function(option) {
    return _c('option', {
      domProps: {
        "value": option.OPTION.VALUE,
        "textContent": _vm._s(option.OPTION.TEXT)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-headline"
    }
  }, [_vm._v("Überschrift:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.editMemo.headline),
      expression: "editMemo.headline"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "id": "memo-headline",
      "placeholder": "Überschrift..."
    },
    domProps: {
      "value": (_vm.editMemo.headline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editMemo, "headline", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-summary"
    }
  }, [_vm._v("Zusammenfassung:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMemo.summary),
      expression: "editMemo.summary"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "memo-summary",
      "placeholder": "Zusammenfassung..."
    },
    domProps: {
      "value": (_vm.editMemo.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editMemo, "summary", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-proxy"
    }
  }, [_vm._v("Vertreter:")]), _vm._v(" "), _vm._l((_vm.editMemo.userClientRef), function(userClient) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('span', {
      staticClass: "tag label label-default"
    }, [_c('span', [_vm._v("\n                      " + _vm._s(userClient.firstName) + " " + _vm._s(userClient.lastName) + " " + _vm._s(userClient.department) + " " + _vm._s(userClient.room) + " " + _vm._s(userClient.function) + "\n                    ")]), _vm._v(" "), _c('a', [_c('i', {
      staticClass: "remove glyphicon glyphicon-remove-sign glyphicon-white",
      attrs: {
        "title": "Vertreter entfernen"
      },
      on: {
        "click": function($event) {
          return _vm.onRemoveAbsence(userClient)
        }
      }
    })])])])
  })], 2), _vm._v(" "), (0) ? _c('user-client-typeahead', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    on: {
      "onHit": _vm.onAddAbsence
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "padding-bottom": "12px"
    },
    attrs: {
      "for": "memo-text"
    }
  }, [_vm._v("Beschreibung:")]), _vm._v(" "), (_vm.preview) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "margin-left": "5em"
    },
    attrs: {
      "type": "button",
      "title": "Vorschau"
    },
    on: {
      "click": function($event) {
        _vm.preview = !_vm.preview
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("Bearbeiten\n                ")]) : _c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "margin-left": "5em"
    },
    attrs: {
      "type": "button",
      "title": "Beschreibung berabeiten"
    },
    on: {
      "click": function($event) {
        _vm.preview = !_vm.preview
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("Vorschau\n                ")]), _vm._v(" "), (!_vm.preview) ? _c('span', [_c('button', {
    staticClass: "btn btn-link",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "title": "Formatiere als 'wichtig'"
    },
    on: {
      "click": _vm.onStyleWichtig
    }
  }, [_vm._v("\n                  wichtig\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button",
      "title": "vom Auftraggeber gewünscht"
    },
    on: {
      "click": _vm.onStyleDaten
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black",
      "background-color": "yellow"
    }
  }, [_vm._v("Daten")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button",
      "title": "Textvorschlag im Gespräch"
    },
    on: {
      "click": _vm.onStyleText
    }
  }, [_c('span', {
    staticStyle: {
      "background-color": "lightgreen"
    }
  }, [_vm._v(" >>> ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("wörtlich")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black",
      "background-color": "lightgreen"
    }
  }, [_vm._v(" <<< ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button",
      "title": "Formatiere als 'Überschrift'"
    },
    on: {
      "click": _vm.onStyleBlod
    }
  }, [_c('b', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Überschrift")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMemo.text),
      expression: "editMemo.text"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "memo-text",
      "rows": "6",
      "placeholder": "Beschreibung ..."
    },
    domProps: {
      "value": (_vm.editMemo.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editMemo, "text", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.preview) ? _c('div', {
    staticStyle: {
      "border": "1px solid lightgrey",
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text2html())
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-type"
    }
  }, [_vm._v("Ansicht der Beschreibung:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMemo.view),
      expression: "editMemo.view"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "memo-view"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editMemo, "view", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.MemoView.TYP), function(option) {
    return _c('option', {
      domProps: {
        "value": option.OPTION.VALUE,
        "textContent": _vm._s(option.OPTION.TEXT)
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-datetime-begin"
    }
  }, [_vm._v("Beginn :")]), _vm._v(" "), _c('cc-datetime', {
    attrs: {
      "label_id": "memo-datetime-begin"
    },
    model: {
      value: (_vm.editMemo.datetimeBegin),
      callback: function($$v) {
        _vm.$set(_vm.editMemo, "datetimeBegin", $$v)
      },
      expression: "editMemo.datetimeBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-datetime-end"
    }
  }, [_vm._v("Ende :")]), _vm._v(" "), _c('cc-datetime', {
    attrs: {
      "label_id": "memo-datetime-end"
    },
    model: {
      value: (_vm.editMemo.datetimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.editMemo, "datetimeEnd", $$v)
      },
      expression: "editMemo.datetimeEnd"
    }
  })], 1)], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "form": _vm._uid
    }
  }, [_vm._v("\n              Speichern\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel', _vm.memo)
      }
    }
  }, [_vm._v("\n              Abbrechen\n            ")]), _vm._v(" "), (_vm.editMemo.id) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('remove', _vm.memo)
      }
    }
  }, [_vm._v("\n              Löschen\n            ")]) : _vm._e()])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64c53240!./~/vue-loader/lib/selector.js?type=template&index=0!./src/MemoModal.vue
// module id = 279
// module chunks = 0